import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Container, FormGroup, Label, Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { MdAdd, MdRemove } from "react-icons/md";

import { getMediums, saveMediumItems } from "../../store/actions/mediums";
import { getAllChannels } from "../../store/actions/channels";

import Button from "../../components/Form/Button";
import Channel from "../../components/Channels/Channel";


import List from "../../components/List"

class MediumHomeSettings extends React.PureComponent {
  constructor(props) {
    super();
    this.state = {
      mediums: props.mediums
    }
  }
  componentDidMount() {
    if (!this.props.mediums) this.props.getMediums();
    if (Object.keys(this.props.channels).length < 2) this.props.getAllChannels();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.mediums && !this.props.mediums) {
      this.setState({ mediums: nextProps.mediums })
    }
    if(!nextProps.loading && this.props.loading) this.setState({mediums: this.state.mediums.map(medium=>({...medium, changed: false}))})
  }
  removeChannel = (mediumIndex, channel) => {
    const newArray = this.state.mediums[mediumIndex].items.filter(ch => ch.id !== channel.id);
    this.updateMedium(mediumIndex, {items: newArray});
  };
  updateMedium = (mediumIndex, data) => {
    const mediums = this.state.mediums;
    this.setState({
      mediums: [
        ...mediums.slice(0, mediumIndex),
        {
          ...mediums[mediumIndex],
          ...data,
          items: data.items?data.items.map((item, index) => ({ ...item, index: index + 1 })):mediums[mediumIndex].items
        },
        ...mediums.slice(mediumIndex+1)
      ]
    })
  }
  saveMedium = (medium) => {
    this.props.saveMediumItems({
      ...medium,
      enabled: true,
      items: medium.items.map(item => ({
        automaticId: item.automaticId,
        promotedId: item.promotedId,
        liveId: item.liveId,
        index: item.index
      }))
    })
  }
  render() {
    return (
      <Container fluid>
        <div className="d-flex align-items-center mb-4">
          <h4>تنظیمات چینش کانال‌ها در سایر برنامه‌ها</h4>          
        </div>
        {
          Object.keys(this.props.channels).length > 0 && this.state.mediums && this.state.mediums.length > 0 && this.state.mediums.map((medium, mediumIndex)=>(
            <Card key={medium.id}>
              <CardHeader className="cursor-pointer" onClick={()=>this.updateMedium(mediumIndex, {collapsed: !this.state.mediums[mediumIndex].collapsed})}>
                <h5 className="m-0 d-flex align-items-center">
                  {medium.media}
                  {medium.collapsed?<MdAdd className="mr-auto"/>:<MdRemove className="mr-auto"/>}
                </h5>
              </CardHeader>
              {
                !medium.collapsed &&
                <React.Fragment>
                  <CardBody>
                    <FormGroup>
                      <Label>برای افزودن کانال از قسمت زیر استفاده کنید</Label>
                      <Typeahead
                        id="search-channels"
                        options={Object.values(this.props.channels).filter(channel => channel.status === 'ACTIVE' && !medium.items.map(ch => ch.chId).includes(channel.id))}
                        labelKey="name"
                        promptText="برای جستجو شروع به نوشتن کنید"
                        placeholder=" جستجو و انتخاب کانال برای افزودن"
                        emptyLabel="کانالی پیدا نشد"
                        paginationText="نمایش کانال‌های بیشتر"
                        ref={node => this.channelSelector = node}
                        renderMenuItemChildren={result => (<Channel channel={this.props.channels[result.id]} noLink coverSize={40} className="p-0 mb-2" />)}
                        disabled={!Object.keys(this.props.channels).length}
                        onChange={selected => {
                          if (selected && selected.length) {
                            const channel = selected[0];
                            this.updateMedium(mediumIndex, {changed:true,items:[
                              {
                                [`${channel.type.split('_')[0].toLowerCase()}Id`]: channel.id,
                                chId: channel.id,
                              },
                              ...medium.items]});
                            this.channelSelector.getInstance().clear();
                          }
                        }}
                      />
                    </FormGroup>
                    <List
                      sortable
                      axis="y"
                      lockAxis="y"
                      lockToContainerEdges
                      useDragHandle
                      parentClassName="list-unstyled"
                      useWindowAsScrollContainer
                      render={channel => (
                        <Channel channel={this.props.channels[channel.chId]} noLink />
                      )}
                      items={medium.items}
                      remove={data => this.removeChannel(mediumIndex, data)}
                      sort={newItems =>
                        this.updateMedium(mediumIndex, {items: newItems, changed: true})
                      }
                      showOnHover
                    />
                  </CardBody>
                  <CardFooter>
                      <Button
                        className="mr-auto"
                        color="success"
                        disabled={!medium.changed}
                        loading={this.props.loading}
                        onClick={()=>this.saveMedium(medium)}
                      >
                        ذخیرهٔ تغییرات
                    </Button>
                  </CardFooter>                  
                </React.Fragment>
              }              
            </Card>
          ))
        }
      </Container>
    )
  }
}

export default connect(
  state => (
    {
      mediums: state.mediums,
      loading: state.loading.medium,
      channels: state.channels
    }
  ),
  dispatch => bindActionCreators({
    getMediums,
    saveMediumItems,
    getAllChannels
  }, dispatch)
)(MediumHomeSettings)